import $ from 'jquery';
import ellipsis from './utilities/jquery.ellipsis.js';

var stepOneButton = $('#edit-actions-01-submit');
var stepTwoButton = $('#edit-go-step-third-submit');
var stepOneSection = $('.step_one .webform-section-accordion');
var stepTwoSection = $('.step_two .webform-section-accordion');
var stepThreeSection = $('.step_three .webform-section-accordion');
var cancelButton = $('#edit-cancel-button-submit');
var detailsWrapper = $('.field--name-webform details.form-wrapper');
var themesDetailCheckbox = $('.field--name-webform details.form-wrapper#edit-themes .form-type-checkbox');
var checkboxDescription = $('.field--name-webform details.form-wrapper .form-checkboxes .description .webform-element-description');
var showNextAttachment = $('.field--name-webform .attachment-container .show-next-attachment');

function scrollTo(el) {
  $('html, body').animate(
    {
      scrollTop: el.offset().top
    },
    500
  );
}

stepOneSection.addClass('expanded');
stepTwoSection.click().removeClass('expanded');
stepThreeSection.click().removeClass('expanded');

stepOneButton.on('click', function(e) {
  e.preventDefault();
  if (!stepTwoSection.hasClass('expanded')) {
    stepTwoSection.click();
  }
  scrollTo(stepTwoSection);
});

stepTwoButton.on('click', function(e) {
  e.preventDefault();
  if (!stepThreeSection.hasClass('expanded')) {
    stepThreeSection.click();
  }
  scrollTo(stepThreeSection);
});

cancelButton.on('click', function(e) {
  e.preventDefault();
  location.reload();
});

let attachmentButtonClicked = 0;
$('.webform-section-wrapper').on('click', '.webform-managed-file-placeholder', function(){
  if (attachmentButtonClicked > 0) {
    $(this).next().trigger('click');
  }
  attachmentButtonClicked++;
})

showNextAttachment.on('click', function(){
  $(this).addClass('expanded');
})

jQuery(document).ready(function($){
  // make all detail wrapper opened when page loaded
  detailsWrapper.each(function(){
    $(this).attr('open', 'open');
  })

  detailsWrapper.on('click', 'summary', function(e){
    if ($(window).width() > 1070 && $(this).parent().attr('open')) {
      e.preventDefault();
      e.stopPropagation();
    }
  })

  // checkbox description truncation
  var truncationTimeout;
  themesDetailCheckbox.on('click', function(){
    clearTimeout(truncationTimeout);
    truncationTimeout = setTimeout(function(){
      truncatedCheckboxDescription();
    }, 300);
  })

  $(window).resize(function(){
    truncatedCheckboxDescription();
  })

  checkboxDescription.on('click', function(){
    $(this).toggleClass('expanded');
  })

  function truncatedCheckboxDescription() {
    checkboxDescription.each(function(){
      if ($(this).height() <= 0 || $(this).find('.ellip').length) {
        return;
      }

      $(this).css('width', $(this).closest('details').width() - 71);
      $(this).ellipsis({
        lines: 3,
        ellipClass: 'ellip',
        responsive: true
      });
      if (isEllipsisActive($(this).find('.ellip-line')[0])) {
        $(this).removeClass('noEllipsis');
      } else {
        $(this).addClass('noEllipsis');
      }
    })
  }

  function isEllipsisActive(e) {
    return (e ? e.offsetWidth < e.scrollWidth : false);
  }
})